import { Keys, Scene, Vector } from "excalibur";
import { gameState, inventoryState, playerState } from "../state/stateManager";
import { goToScene } from "../main";
import { checkFirstSale, createGainedItem, sendAlert } from "../utils";
import { Resources } from "../Resources";
import Colin from "../actors/characters/colin";
import { Player } from "../player";
import InventoryHUD from "../ui/inventory";
import Kennedy from "../actors/characters/kennedy";
import jar from "./../../res/jar.png";
export default class FurdlandCommerce extends Scene {
  constructor() {
    super();

    this.active = 0;
    this.sellHoney = false;
    this.selected = false;
    this.cashout = false;
    const player = new Player(29 * 16, 9 * 16);
    this.player = player;
    this.player.z = 5;
    this.player.wearingVeil = false;
    this.player.lastDir = "up";
    this.kennedy = new Kennedy({ x: 29 * 16, y: 6 * 16 });
    this.kennedy.z = 4;
    this.kennedy.cutScene = true;
    this.player.cutScene = true;
    this.shelfSpace = 1000;
    this.minimum = 500;
    this.offering = 3;
  }
  onActivate(engine) {
    this.inventory = inventoryState.getInventory();
    this.coins = gameState.getCoins();
    Resources.FurdlandMap.addToScene(this);
    this.getShelfSpace();
    this.add(this.player);
    this.add(this.kennedy);
    if (this.inventory.filledJars >= this.minimum) {
      this.jarsToAdd = this.minimum;
    } else {
      this.jarsToAdd = this.inventory.filledJars;
    }

    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.classList.add("commerce");
    this.menuContainer.classList.remove("beeMarketCommerce");
    this.menuContainer.style.display = "flex";
    this.menu = document.getElementById("feed-menu");
    console.log("menu: ", this.menu);
    this.menu.style.display = "block";
    this.drawMenu();
    this.inventoryHUD = new InventoryHUD("furdlandCommerce");
  }
  drawMenu() {
    console.log("inside drawmenu: ", this.active);
    let jarAlert = "";
    if (this.inventory.filledJars < this.minimum) {
      jarAlert = `<h3>You Don't Have Enough Jars</h3>`;
    }
    if (this.active == 0) {
      this.menu.innerHTML = `<h1>Furdland SuperMart</h1>
        <h3>Minimum Jars For Sale: ${this.minimum}</h3>
          ${jarAlert}
        <ul>
            <li id="list0"><span id="selector">></span>Sell Honey</li>
            <li id="list1">Buy Items</li>
          
          </ul>
       
        `;
    } else if (this.active == 1) {
      this.menu.innerHTML = `<h1>Furdland SuperMart</h1>
        <h3>Minimum Jars For Sale: ${this.minimum}</h3>
        ${jarAlert}
        <ul>
            <li id="list0">Sell Honey</li>
            <li id="list1"><span id="selector">></span>Buy Items</li>
          
          </ul>
       
        `;
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play(2);
      if (this.sellHoney) {
        if (this.jarsToAdd + 1 <= this.inventory.filledJars) {
          this.jarsToAdd++;
          this.openSellHoneyMenu();
        } else {
          Resources.Error.play();
          sendAlert("Not Enough Jars");
        }
      } else {
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play(2);
      if (this.sellHoney) {
        this.jarsToAdd = this.jarsToAdd - 1;
        this.openSellHoneyMenu();
      } else {
        console.log("active : ", this.active);
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      Resources.Inventory.play();
      if (this.active == 0) {
        //restock
        this.selected = true;
        this.sellHoney = true;
        this.openSellHoneyMenu();
      } else if (this.active == 1) {
        //cash out
        this.selected = true;
        this.buyItems = true;
        this.openBuyItemsMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      Resources.Inventory.play();
      if (this.selected) {
        this.drawMenu();
        this.sellHoney = false;
        this.buyItems = false;
        this.selected = false;
      } else {
        goToScene("furdland");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log(
        "space: selling: ",
        this.sellHoney,
        " cashOut: ",
        this.buyItems
      );
      if (this.sellHoney) {
        if (this.jarsToAdd >= this.minimum) {
          this.inventory.filledJars =
            this.inventory.filledJars - this.jarsToAdd;

          //set last sold on Furdland SuperMart state
          //get cash
          let con = playerState.getContent();
          con.furdland.lastSold = new Date().getTime();
          con.brandAwareness = con.brandAwareness + (0.5 * this.jarsToAdd) / 10;
          playerState.setContent(con);
          let coins = gameState.getCoins();
          coins = coins + parseInt(this.jarsToAdd * this.offering);
          gameState.setCoins(coins);
          inventoryState.setInventory(this.inventory);
          Resources.Coins.play();
          checkFirstSale();
          this.inventoryHUD.display();
          createGainedItem(`$${parseInt(this.jarsToAdd * this.offering)}`);
          this.getShelfSpace();
          this.selected = false;
          this.active = 0;
          if (this.inventory.filledJars >= this.minimum) {
            this.jarsToAdd = this.minimum;
          } else {
            this.jarsToAdd = this.inventory.filledJars;
          }
          this.drawMenu();
        } else {
          Resources.Error.play();
          sendAlert(`Doesn't Meet Minimum: ${this.minimum} Jars`);
        }
      } else if (this.buyItems) {
      }
    }
  }
  onDeactivate() {
    this.menuContainer.style.display = "none";
    this.menu.style.display = "none";
    this.menuContainer.classList.remove("commerce");
    this.inventoryHUD.destroy();
  }
  openBuyItemsMenu() {
    this.menu.innerHTML = `<h1>Furdland SuperMart</h1>
    
    <h3>Minimum Jars For Sale: ${this.minimum}</h3>
  
   
    `;
  }
  openSellHoneyMenu() {
    if (this.inventory.filledJars < this.minimum) {
      this.menu.innerHTML = `<h1>Furdland SuperMart</h1>
      <h3>Minimum Jars For Sale: ${this.minimum}</h3>
      <h3>Offering $${this.offering} per jar</h3>
      <h3>You Don't Have Enough Jars</h3>
     
      <h3>Jars To Sell</h3><h3><img class="productImage"src="${jar}"/><span class="iterate">${this.jarsToAdd}</span></h3><p>Use Arrow Keys To Iterate</p><p>Hit Space To Sell</p><p>X> BACK</p>
     
      `;
    } else {
      this.menu.innerHTML = `<h1>Furdland SuperMart</h1>
    <h3>Minimum Jars For Sale: ${this.minimum}</h3>
    <h3>Offering $${this.offering} per jar</h3>
   
    <h3>Jars To Sell</h3><h3><img class="productImage"src="${jar}"/>${this.jarsToAdd}</h3><p>Use Arrow Keys To Iterate</p><p>Hit Space To Sell</p><p>X> BACK</p>
   
    `;
    }
  }

  getTimePassed(unTranslatedTime) {
    let speed = gameState.getGameSpeed();
    let transTime = speed * unTranslatedTime;
    let hours = transTime / 3600000;
    console.log("time passed: ", hours, " hours");
    let totalShelfSpace = 0;
    let totalTime = 72;
    if (hours >= 720) {
      //give full availability
      totalShelfSpace = this.minimum * 2;
    } else {
      //fraction availability by time
      let frac = hours / 72;
      totalShelfSpace = this.minimum * 2 * frac;
    }
    return totalShelfSpace;
  }
  getShelfSpace() {
    this.content = playerState.getContent();

    if (this.content.furdland.lastSold == null) {
      //full jar availablility
      this.shelfSpace = 40;
    } else {
      //base jar availability on last sold and relationship with kennedy and random
      this.shelfSpace = this.getTimePassed(
        new Date().getTime() - this.content.furdland.lastSold
      );
    }
  }
}
